/**
 * The canonical partner slug.
 *
 * Transcribed from column J of sparkery-competition-partner-links.xlsx:
 *
 *   LOWER(SUBSTITUTE(... TRIM($B10)," ","-"),"'",""),"&","and"),",",""),".",""),"–","-"))
 *
 * This one function is used by BOTH link generation and the GA4 sessionSource filter.
 * If those two ever disagree, traffic silently stops joining to sales — which is why
 * it lives in contracts and is covered by the table of cases in slug.test.ts.
 *
 * Order matters: "&" becomes "and" before spaces collapse, so "Peak & Co" gives
 * "peak-and-co" rather than "peak--and--co".
 */
export function partnerSlug(name: string): string {
  return name
    .trim()
    .replace(/&/g, ' and ')
    .replace(/['’]/g, '')
    .replace(/[,.]/g, '')
    .replace(/[–—]/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
}
